import { getters } from '@/modules/core/app/helpers/store';
import { AppModule } from '@/modules/core/app/constants/app.constants';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';

export class ResearchRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    return getters.session.getUserSettings().isModuleAvailable(AppModule.COMPETITOR_RESEARCH);
  }
}
